module.exports = __webpack_public_path__ + "img/04.617b3cfa.jpg";